import superagent from '@ott/superagent';
import { getFromLocalStorage, saveToLocalStorage, removeFromLocalStorage } from './localStorage';
import { addEnvNode, removeEnvNode } from './dom';
import addSecretListener from './addSecretListener';
import { LOCALSTORAGE_PARAMS_VAR, LOCALSTORAGE_VAR } from './consts';
import { isLocalStorageAvailable } from '@ott/utility-localstorage';

const REQUEST_DELAY = 1000;
const DEFAULT_CONFIG = {
  localStorageTestPgKey: null,
};

const checkIsEnvNodeShown = () => getFromLocalStorage(LOCALSTORAGE_VAR);

export const getRequestParams = (forGetParams) => {
  const params = checkIsEnvNodeShown() && getFromLocalStorage(LOCALSTORAGE_PARAMS_VAR);
  if (!params) {
    return forGetParams ? '' : {};
  }
  if (forGetParams) {
    return params;
  }

  const result = {};
  params.split('&').forEach((param) => {
    const keyValue = param.split('=');
    result[keyValue[0]] = keyValue[1];
  });

  return result;
};

let cachedResponse = null;
const setEnvNode = ({ shouldInvalidateCache, ...restConfigProps }) => {
  if (shouldInvalidateCache) {
    cachedResponse = null;
  }
  if (checkIsEnvNodeShown()) {
    if (!cachedResponse) {
      setTimeout(() => {
        superagent
          .get('/_api/system/info2')
          .query({})
          .end((err, res) => {
            cachedResponse = res.body;
            addEnvNode({
              data: res.body,
              ...restConfigProps,
            });
          });
      }, REQUEST_DELAY);
    } else {
      addEnvNode({
        data: cachedResponse,
        ...restConfigProps,
      });
    }
  }
};

let hasListener = false;

export const envEasterEgg = (config = DEFAULT_CONFIG) => {
  if (!isLocalStorageAvailable) {
    return;
  }

  if (!hasListener) {
    addSecretListener(() => {
      if (checkIsEnvNodeShown()) {
        removeFromLocalStorage(LOCALSTORAGE_VAR);
        removeEnvNode();
      } else {
        saveToLocalStorage(LOCALSTORAGE_VAR, true);
        setEnvNode({ shouldInvalidateCache: false, ...config });
      }
    });
    hasListener = true;
  }
  if (checkIsEnvNodeShown()) {
    removeEnvNode();
  }
  setEnvNode({ shouldInvalidateCache: true, ...config });
};
